// extracted by mini-css-extract-plugin
module.exports = {"top":"Layout_top__1lboB","topBottomGutter":"Layout_topBottomGutter__2VjBa"};